// extracted by mini-css-extract-plugin
export default {"titleContainer":"styles-module__[local]___7PdBn","title":"styles-module__[local]___GfGsB","ctaContainer":"styles-module__[local]___m4eem"};